import { Component, h } from '@stencil/core';

@Component({
  tag: 'icon-swag-boxes'
})
export class TwitterIcon {
  render() {
    return (
      <svg version="1.1" id="ci-swag-boxes-Layer_1" x="0px" y="0px"
      	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xmlSpace="preserve">
      <g id="ci-swag-boxes-package-check">
      	<path id="ci-swag-boxes-Icon__x28_Stroke_x29_" fill-rule="evenodd" clip-rule="evenodd" fill="#252525" d="M11.6,1.2c0.3-0.1,0.5-0.1,0.8,0
      		c0.3,0.1,0.6,0.2,0.8,0.3c0,0,0,0,0.1,0l-0.5,0.9l0.5-0.9l7.4,4.1c0,0,0,0,0.1,0C21,5.8,21.2,6,21.5,6.2l-0.3,0.3l0.3-0.3
      		c0.2,0.2,0.3,0.5,0.4,0.7C22,7.3,22,7.6,22,7.9c0,0,0,0,0,0.1v4.6c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1V8.7l-3,1.7c0,0,0,0,0,0l-4,2.2
      		l0,7.7l0.5-0.3c0.5-0.3,1.1-0.1,1.4,0.4c0.3,0.5,0.1,1.1-0.4,1.4l-1.2,0.7c0,0,0,0-0.1,0c-0.2,0.1-0.5,0.3-0.8,0.3
      		c-0.3,0.1-0.5,0.1-0.8,0c-0.3-0.1-0.6-0.2-0.8-0.3c0,0,0,0-0.1,0l-7.4-4.1c0,0,0,0-0.1,0C3,18.2,2.8,18,2.5,17.8
      		c-0.2-0.2-0.3-0.5-0.4-0.7C2,16.7,2,16.4,2,16.1c0,0,0,0,0-0.1V7.9c0,0,0,0,0-0.1C2,7.6,2,7.3,2.1,7c0.1-0.3,0.2-0.5,0.4-0.7
      		C2.8,6,3,5.8,3.3,5.7c0,0,0,0,0.1,0h0l3.7-2c0,0,0,0,0,0l3.7-2.1c0,0,0,0,0.1,0C11,1.4,11.3,1.2,11.6,1.2z M7.5,5.6L5.1,7l6.9,3.9
      		l2.4-1.4L7.5,5.6z M16.5,8.4L9.6,4.5l2.1-1.2c0.2-0.1,0.2-0.1,0.3-0.2c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1,0.1,0.3,0.2L18.9,7
      		L16.5,8.4z M11,12.6L4,8.7v7.4c0,0.2,0,0.3,0,0.3c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.1,0.1,0.3,0.2l-0.5,0.9l0.5-0.9l6.7,3.7L11,12.6
      		z M22.7,15.3c0.4,0.4,0.4,1,0,1.4l-4,4c-0.4,0.4-1,0.4-1.4,0l-2-2c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l1.3,1.3l3.3-3.3
      		C21.7,14.9,22.3,14.9,22.7,15.3z"/>
      </g>
      </svg>
    );
  }
}
